import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children"];
import PropTypes from 'prop-types';
import React from 'react';
import { withIcon } from '../Icon';
var innerSvg = '<g stroke="none"><path d="M27.733 9.224A1.01 1.01 0 0 0 26.75 8h-.57c-.409 0-.77.257-.965.617-2.06 3.8-6.91 1.61-8.017-1.757-.158-.48-.573-.86-1.078-.86h-.234c-.504 0-.92.38-1.077.86-1.108 3.368-5.957 5.558-8.018 1.757C6.596 8.257 6.235 8 5.826 8h-.57a1.01 1.01 0 0 0-.983 1.224 83.458 83.458 0 0 1 1.513 9.854c.047.52.48.922 1.003.922h18.428a1.01 1.01 0 0 0 1.003-.922 83.59 83.59 0 0 1 1.514-9.854z"></path><path d="M25.98 23.047A1.015 1.015 0 0 0 24.973 22H7.034c-.57 0-1.024.477-1.009 1.047.021.773.022 1.403.015 1.88-.009.58.457 1.073 1.037 1.073H24.93c.58 0 1.046-.492 1.037-1.073a45.032 45.032 0 0 1 .015-1.88z"></path></g>';
export var CrownSVG = function CrownSVG(_ref) {
  var children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    dangerouslySetInnerHTML: {
      __html: innerSvg
    }
  }));
};
CrownSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node
} : {};
export default withIcon(CrownSVG);